import {
  CButton, CContainer, CForm, CFormGroup,
  CInput, CLabel, CModal, CModalBody, CModalFooter, CModalHeader,
  CModalTitle, CRow, CAlert, CFormText
} from '@coreui/react';
import React, { useState, useEffect } from 'react';
import { fs } from '../../firebase';
import Notify from '../../utils/Notify';

export default function AddChapterModal(props) {
  const book = props.book;
  const bookRef = props.bookRef;
  const chapterModel = { number: '', references: '', verses: [] }
  const [chapter, setChapter] = useState(chapterModel)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleAddChapter() {
    setError('')
    if (!chapter.number || !parseInt(chapter.number)) {
      setError('Please enter valid Chapter Number')
      return;
    }

    setLoading(true)

    try {
      var exist = book.chapters.find(item => item.number == chapter.number)
      if (exist != undefined) {
        book.chapters = book.chapters.map(item => {
          if (item.number == chapter.number) {
            return chapter
          } else {
            return item
          }
        })
      } else {
        book.chapters.push(chapter)
      }

      await bookRef.doc(book.number.toString()).set(book)
      setLoading(false)
      props.onClose()
      let message = 'Chapter added successfully.'
      if (props.chapter) {
        message = 'Chapter updated successfully.'
      }
      Notify.success(message)
    } catch (error) {
      setLoading(false)
      setError('Something went wrong, Please try again')
      console.log(error)
    }
  }

  useEffect(() => {
    if (props.chapter) {
      setChapter(props.chapter)
    }
  }, [])

  return (
    <CModal
      show={props.show}
      centered={false}
      onClose={() => props.onClose()}
      className="border-dark"
    >
      <CModalHeader closeButton>
        <CModalTitle>{props.chapter ? 'Edit' : 'Add'} Chapter</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow >
            {
              error && <CAlert color="danger" className="w-100">{error}</CAlert>
            }
            <CForm className="w-100"
              onSubmit={e => {
                e.preventDefault()
                handleAddChapter()
              }}>
              <CFormGroup className="w-100">
                <CLabel>Chapter Number</CLabel>
                <CInput
                  readOnly={props.chapter}
                  className="w-100"
                  value={chapter.number}
                  type="number"
                  placeholder="Enter Chapter Number"
                  onChange={(e) => setChapter({ ...chapter, number: parseInt(e.target.value) })}
                />
                <CFormText>Note: If Chapter already exist, It wil be overwritten.</CFormText>
              </CFormGroup>
              <CFormGroup className="w-100">
                <CLabel>References <small>(Optional)</small></CLabel>
                <CInput
                  className="w-100"
                  value={chapter.references}
                  type="text"
                  placeholder="Enter references"
                  onChange={(e) => setChapter({ ...chapter, references: e.target.value })}
                />
              </CFormGroup>
            </CForm>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton color="danger" variant="outline" className="btn-sm pl-2 pr-2"
          disabled={loading}
          onClick={() => props.onClose()}>Cancel</CButton>
        <CButton color="dark" className="btn-sm pl-4 pr-4" type="submit"
          disabled={loading}
          onClick={(e) => {
            e.preventDefault()
            handleAddChapter()
          }
          }>Save</CButton>
      </CModalFooter>
    </CModal>
  )
}
